import Api from '../Api';

export const getCostSheets = () => async dispatch => {
  const { data } = await Api.get('/cost-sheets');
  dispatch({
    type: 'FETCH_COST_SHEETS',
    payload: data,
  });
};

export const clearCostSheets = () => {
  return {
    type: 'CLEAR_COST_SHEETS',
  };
};

export const getCostSheet = id => async dispatch => {
  const { data } = await Api.get(`/cost-sheets/${id}`);
  dispatch({
    type: 'FETCH_COST_SHEET',
    payload: data,
  });
};

export const clearCostSheet = () => {
  return {
    type: 'CLEAR_COST_SHEET',
  };
};
